module.exports = __webpack_public_path__ + "img/logo_ministerio.673a6756.png";